import type { RectangleLike } from '@/app/grid/sheet/SheetCursor';

// Whether world-space bounds overlap the frozen rows/columns band. Frozen content
// is drawn by pinned pane passes regardless of scroll, so culling must not
// depend on the viewport position on the frozen axis (unlike the scrollable body).
export function intersectsFrozenBand(
  bounds: RectangleLike,
  frozenRows: number,
  frozenColumns: number,
  boundary: { x: number; y: number }
): boolean {
  const inFrozenColumns = frozenColumns > 0 && bounds.x < boundary.x;
  const inFrozenRows = frozenRows > 0 && bounds.y < boundary.y;
  return inFrozenColumns || inFrozenRows;
}
